import React from 'react';
import { FlameIcon } from 'lucide-react';
import { CtaBlock } from './CtaBlock';
import { WORKSHOP_IMAGE } from '../data/content';
export function FinalCta() {
  return <section className="relative overflow-hidden border-t border-ink-700 bg-ink-950" data-id="element-93" data-mp="vhiqxpfe8s4m">
      <img src={WORKSHOP_IMAGE} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-25" loading="lazy" data-id="element-94" data-mp="19cuoe4kxowp8" />
      <div className="absolute inset-0 bg-ink-950/80" aria-hidden="true" data-id="element-95" data-mp="1jbaimgf9cm2y" />

      <div className="relative mx-auto w-full max-w-2xl px-4 py-14 text-center sm:px-6 sm:py-20" data-id="element-96" data-mp="1ed8wtnqg68ns">
        <div className="mx-auto flex w-fit items-center gap-2 rounded-full border border-brand/40 bg-brand/10 px-3 py-1.5" data-id="element-97" data-mp="1t1mz9xjybv3t">
          <FlameIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-98" data-mp="1o4n0m7pflumq" />
          <span className="text-[10px] font-bold uppercase tracking-[0.14em] text-brand sm:text-xs" data-id="element-99" data-mp="224ee87c1d907">
            Wenn du das nächste Mal dein Schweißgerät einschaltest…
          </span>
        </div>

        <h2 className="mt-5 font-display text-[28px] uppercase leading-[1.05] text-white sm:text-5xl" data-id="element-100" data-mp="n6w4qshzte91">
          Du kannst weiterhin improvisieren…
        </h2>
        <p className="mt-4 text-[15px] leading-relaxed text-white/75 sm:text-lg" data-id="element-101" data-mp="x38zzut6s05w">
          Oder du kannst mit mehr Sicherheit beginnen, weil du eine klare Referenz hast, die dir
          zeigt, was du vor dem Start überprüfen solltest.
        </p>

        <ul className="mx-auto mt-6 max-w-sm space-y-2 text-left" data-id="element-102" data-mp="1646unmhqivbt">
          {['Öffne das Meister-System.', 'Überprüfe die passende Einstellung.', 'Beginne deine nächste Schweißpraxis mit mehr Klarheit.'].map((step, index) => <li key={step} className="flex items-center gap-3 rounded-xl border border-ink-600 bg-ink-900/80 px-4 py-3" data-id="element-103" data-mp="1ks1oj67hb5qh" data-mpi={index}>
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-brand font-display text-sm text-ink-950" data-id="element-104" data-mp="1ttroj0fffczv">
                {index + 1}
              </span>
              <span className="text-[15px] leading-snug text-white/85" data-id="element-105" data-mp="3lvkp677xf204">{step}</span>
            </li>)}
        </ul>

        <CtaBlock label="Ich will das Meister-Schweisssystem" className="mt-8" data-id="element-106" data-mp="3huxj0knqvky" />

        <p className="mt-4 font-semibold text-white" data-id="element-107" data-mp="3uwiucsu3pfka">Einmalige Zahlung von 19 €</p>
        <ul className="mt-2 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-xs font-medium text-white/70 sm:text-sm" data-id="element-108" data-mp="3uufsnbjl5xzq">
          {['Sofortiger Zugang', 'Lebenslanger Zugang', '7 Tage Garantie'].map(item => <li key={item} className="flex items-center gap-1.5" data-id="element-109" data-mp="mgz1huxcdz5r">
              <span className="text-brand" aria-hidden="true" data-id="element-110" data-mp="me4jea1swqfi">
                ✓
              </span>
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}